const TAG = 'USER_'
export const RESET_STORE_USER = 'RESET_STORE_USER';

export const STREET_LIGHT_REQUEST = 'STREET_LIGHT_REQUEST';
export const STREET_LIGHT_SUCCESS = 'STREET_LIGHT_SUCCESS';
export const STREET_LIGHT_ERROR = 'STREET_LIGHT_ERROR';

export const STREET_LIGHT_DETAIL_REQUEST = 'STREET_LIGHT_DETAIL_REQUEST';
export const STREET_LIGHT_DETAIL_SUCCESS = 'STREET_LIGHT_DETAIL_SUCCESS';
export const STREET_LIGHT_DETAIL_ERROR = 'STREET_LIGHT_DETAIL_ERROR';

export const STREET_LIGHT_HISTORY_REQUEST = 'STREET_LIGHT_HISTORY_REQUEST';
export const STREET_LIGHT_HISTORY_SUCCESS = 'STREET_LIGHT_HISTORY_SUCCESS';
export const STREET_LIGHT_HISTORY_ERROR = 'STREET_LIGHT_HISTORY_ERROR';

export const CREATE_STREET_LIGHT_REQUEST = 'CREATE_STREET_LIGHT_REQUEST';
export const CREATE_STREET_LIGHT_SUCCESS = 'CREATE_STREET_LIGHT_SUCCESS';
export const CREATE_STREET_LIGHT_ERROR = 'CREATE_STREET_LIGHT_ERROR';

export const UPDATE_STREET_LIGHT_REQUEST = 'UPDATE_STREET_LIGHT_REQUEST';
export const UPDATE_STREET_LIGHT_SUCCESS = 'UPDATE_STREET_LIGHT_SUCCESS';
export const UPDATE_STREET_LIGHT_ERROR = 'UPDATE_STREET_LIGHT_ERROR';

